import { render, staticRenderFns } from "./PlayedQuestions.vue?vue&type=template&id=00274907&scoped=true"
import script from "./PlayedQuestions.vue?vue&type=script&lang=js"
export * from "./PlayedQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00274907",
  null
  
)

export default component.exports